import "@/App.css";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ContactCTA } from "@/components/ContactCTA";
import { Occasions } from "@/components/Occasions";
import { Editorial } from "@/components/Editorial";
import { Rentals } from "@/components/Rentals";
import { Reviews } from "@/components/Reviews";
import { HowToBook } from "@/components/HowToBook";
import { Terms } from "@/components/Terms";
import { SocialFeed } from "@/components/SocialFeed";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App bg-white text-black">
      <Header />
      <main data-testid="main-content">
        <Hero />
        <Occasions />
        <Rentals />
        <ContactCTA />
        <Reviews />
        <Editorial />
        <HowToBook />
        <Terms />
        <SocialFeed />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        theme="light"
        toastOptions={{
          className:
            "font-body border border-black bg-white text-black rounded-none",
        }}
      />
    </div>
  );
}

export default App;
